module.exports = __webpack_public_path__ + "static/pic03-21cd8300a4278313d24c176167f08bd1.jpg";